import { capitalize, registerExtensions, throwError } from '@nx-data/utilities';

/* eslint-disable prefer-arrow/prefer-arrow-functions */

registerExtensions();

type StringOrNever<T> = T extends string ? T : never;

export type EventHooks<T extends object> = Partial<{
  [K in keyof T as `on${Capitalize<StringOrNever<K>>}`]: (payload: T[K]) => void;
}>;

export class EventDispatcher<T extends object> {
  private isDisposed = false;
  private eventListeners: EventHooks<T>[] = [];

  public registerEventListener(obj: EventHooks<T>) {
    this.throwIfDisposed();
    this.eventListeners.push(obj);
  }

  public removeEventListener(obj: EventHooks<T>) {
    this.throwIfDisposed();
    this.eventListeners.remove(obj);
  }

  public dispatchEvent<K extends keyof T>(eventName: K, value: T[K]) {
    this.throwIfDisposed();
    for (const eventListener of this.eventListeners) {
      try {
        // @ts-ignore Will be fixed by higher TS version
        eventListener[`on${capitalize(eventName)}`]?.(value);
      } catch (e) {
        console.error(e);
        // TODO capture and log event
      }
    }
  }

  public dispose() {
    this.eventListeners = [];
    this.isDisposed = true;
  }

  private throwIfDisposed(): void | never {
    if (this.isDisposed) {
      throwError('Event bus is already disposed');
    }
  }
}

// export function EventListener(eventDispatcher: EventDispatcher<any>) {
//   // eslint-disable-next-line @typescript-eslint/ban-types
//   return function <T extends { new (...args: any[]): {} }>(constructor: T) {
//     return class extends constructor {
//       constructor(...args: any[]) {
//         super(...args);
//         eventDispatcher.registerEventListener(this);
//       }
//     };
//   };
// }
